import { isNil } from 'ramda';

import { Currency, TsrctDemandRequestInput, TsrctDemandRequestSourceReference } from '@/generated/gql/graphql';

import { DemandRequestFormData } from './components/DemandRequestDetailsForm/DemandRequestDetailsForm.schema';

export const formToDemandRequestInput = (
  formDemandRequest: DemandRequestFormData['demandRequest'],
  sourceReferences?: TsrctDemandRequestSourceReference[] | null,
): TsrctDemandRequestInput => {
  return {
    externalReference: sourceReferences?.length ? undefined : formDemandRequest.externalReference,
    currency: (formDemandRequest.currency as Currency) ?? Currency.EUR,
    budget: formDemandRequest.budget ? String(formDemandRequest.budget) : null,
    summary: formDemandRequest.summary ?? '',
    commodityGroupId: formDemandRequest.commodityGroupId,
    lineItems: formDemandRequest.lineItems.map((item) => ({
      description: item.description,
      position: item.position,
      preferredSupplierId: item.preferredSupplierId,
      quantity: String(item.quantity),
      shipmentTerms: item.shipmentTerms,
      title: item.title,
      unitId: item.unitId,
      expectedPricePerUnit: !isNil(item.expectedPricePerUnit) ? String(item.expectedPricePerUnit) : null,
      //
      internalId: item.internalId,
      analysisId: item.analysisId,
      commodityGroupId: item.commodityGroupId,
      contractItemId: item.contractItemId,
      organizationId: item.organizationId,
      commodityId: item.commodityId,
      baselinePricePerUnit: !isNil(item.baselinePricePerUnit) ? String(item.baselinePricePerUnit) : null,
      deliveryLocationId: item.deliveryLocationId,
    })),
  };
};
